(()=>{
if(window.otCollectionFiltersBound)return;
window.otCollectionFiltersBound=true;
function init(root){
 if(root.dataset.ready)return;
 root.dataset.ready='true';
 const type=root.querySelector('[data-type]'),brand=root.querySelector('[data-brand]'),concern=root.querySelector('[data-concern]'),status=root.querySelector('[data-status]');
 const customKeys=['ot_type','ot_brand','ot_concern'];
 let index,catalog,pending,aborter,timer,revision=0;
 let nativeURL=new URL(location.href);
 const active=()=>Boolean(type.value||brand.value||concern?.value);
 const queryState=()=>{const u=new URL(nativeURL);u.searchParams.delete('section_id');u.searchParams.delete('page');customKeys.forEach(k=>u.searchParams.delete(k));if(type.value)u.searchParams.set('ot_type',type.value);if(brand.value)u.searchParams.set('ot_brand',brand.value);if(concern?.value)u.searchParams.set('ot_concern',concern.value);return u};
 const text=(key,fallback)=>root.dataset[key]||fallback;
 async function load(){
  if(catalog)return;
  if(pending)return pending;
  pending=(async()=>{
   const response=await fetch(root.dataset.index);if(!response.ok)throw Error();index=await response.json();
   const list=[];for(let page=1;page<=10;page++){const response=await fetch(root.dataset.url+'/products.json?limit=250&page='+page);if(!response.ok)throw Error();const batch=(await response.json()).products;list.push(...batch);if(batch.length<250)break;}
   catalog=list;
   for(const [select,key,param] of [[type,'type','ot_type'],[brand,'brand','ot_brand']]){
    const value=select.value||nativeURL.searchParams.get(param)||'';
    const values=[...new Set(catalog.map(p=>index[p.handle]?.[key]||(key==='brand'?p.vendor:'')))].filter(Boolean).sort();
    for(const v of values){const o=document.createElement('option');o.value=v;o.textContent=v;select.append(o)}select.value=value;
   }
   if(concern)concern.value=nativeURL.searchParams.get('ot_concern')||concern.value;
  })();try{await pending}catch(e){pending=null;throw e}
 }
 function replaceControls(doc){
  for(const selector of ['#main-collection-filters','.facets-vertical-sort']){
   const old=document.querySelector(selector),fresh=doc.querySelector(selector);if(old&&fresh)old.replaceWith(fresh.cloneNode(true));
  }
 }
 async function render(){
  const rev=++revision;
  aborter?.abort();aborter=new AbortController();
  status.textContent=text('loading','Finding your matches…');
  root.setAttribute('aria-busy','true');
  try{
   await load();if(rev!==revision)return;
   const url=queryState(),request=new URL(url);customKeys.forEach(k=>request.searchParams.delete(k));request.searchParams.set('section_id',root.dataset.section);
   const cards=[];let firstDoc,lastPage=false;
   for(let page=1;page<=50&&!lastPage;page++){
    request.searchParams.set('page',String(page));const response=await fetch(request,{signal:aborter.signal});if(!response.ok)throw Error();
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');if(!firstDoc)firstDoc=doc;
    const pageCards=[...doc.querySelectorAll('#product-grid > li[data-ot-handle]')];cards.push(...pageCards);
    const next=[...doc.querySelectorAll('.pagination a[href]')].some(a=>Number(new URL(a.href,location.origin).searchParams.get('page'))===page+1);
    lastPage=!next||!active();
   }
   if(rev!==revision)return;
   const matches=cards.filter(card=>{
    const m=index[card.dataset.otHandle]||{},p=catalog.find(p=>p.handle===card.dataset.otHandle);
    return(!type.value||m.type===type.value)&&(!brand.value||(m.brand||p?.vendor)===brand.value)&&(!concern?.value||m.concerns?.includes(concern.value));
   });
   const old=document.querySelector('.product-grid-container'),fresh=firstDoc.querySelector('.product-grid-container');
   if(!old||!fresh)throw Error();
   const replacement=fresh.cloneNode(true);let grid=replacement.querySelector('#product-grid');
   if(active()){
    if(!grid){const area=document.createElement('div');area.className='collection page-width';grid=document.createElement('ul');grid.id='product-grid';grid.className='grid product-grid grid--2-col-tablet-down grid--4-col-desktop';area.append(grid);replacement.replaceChildren(area)}
    grid.replaceChildren(...matches.map(card=>card.cloneNode(true)));
    replacement.querySelectorAll('.pagination-wrapper').forEach(n=>n.remove());
    if(!matches.length){const empty=document.createElement('li');empty.className='ot-filter-empty';empty.textContent=text('empty','No matching products. Try another combination or reset the filters.');grid.append(empty)}
   }
   old.replaceWith(replacement);replaceControls(firstDoc);
   const count=active()?matches.length:null;
   if(count!==null){for(const n of document.querySelectorAll('#ProductCount,#ProductCountDesktop'))n.textContent=String(count)+' '+text('products','products');}
   status.textContent=active()?String(matches.length)+' '+text('found','products found'):'';
   history.replaceState({},'',url.pathname+url.search+url.hash);nativeURL=url;
   document.dispatchEvent(new CustomEvent('ot:collection:updated'));
  }catch(e){if(e.name!=='AbortError')status.textContent=text('error','These filters couldn’t load. Please try again.');}
  finally{if(rev===revision)root.removeAttribute('aria-busy')}
 }
 root.querySelectorAll('select').forEach(s=>s.addEventListener('change',()=>{nativeURL=new URL(location.href);render()}));
 root.querySelector('[data-clear]').addEventListener('click',()=>{type.value='';brand.value='';if(concern)concern.value='';for(const k of [...nativeURL.searchParams.keys()])if(k.startsWith('filter.')||customKeys.includes(k)||k==='page')nativeURL.searchParams.delete(k);render()});
 function nativeChange(event){
  if(!root.isConnected||!active()||root.contains(event.target))return;
  const field=event.target;
  if(!field.matches('input[name^="filter."],select[name="sort_by"]'))return;
  event.stopImmediatePropagation();event.preventDefault();
  if(field.name==='sort_by')nativeURL.searchParams.set('sort_by',field.value);
  else{
   const form=field.closest('form');if(!form)return;
   const names=[...new Set([...form.elements].map(n=>n.name).filter(n=>n.startsWith('filter.')))];
   names.forEach(n=>nativeURL.searchParams.delete(n));
   for(const [k,v] of new FormData(form))if(k.startsWith('filter.')&&v!=='')nativeURL.searchParams.append(k,String(v));
  }
  clearTimeout(timer);timer=setTimeout(render,field.name.includes('.price.')?400:0);
 }
 document.addEventListener('input',nativeChange,true);document.addEventListener('change',nativeChange,true);
 document.addEventListener('click',event=>{
  if(!root.isConnected||!active())return;
  const a=event.target.closest('facet-remove a');if(!a)return;event.preventDefault();event.stopImmediatePropagation();
  const u=new URL(a.href);nativeURL=u;render();
 },true);
 document.addEventListener('submit',event=>{if(root.isConnected&&active()&&event.target.matches('facet-filters-form form')){event.preventDefault();event.stopImmediatePropagation();render()}},true);
 window.addEventListener('popstate',()=>{if(root.isConnected)location.reload()});
 root.addEventListener('focusin',()=>load().catch(()=>{}),{once:true});
 load().then(()=>{if(customKeys.some(k=>nativeURL.searchParams.has(k)))render()}).catch(()=>{});
}
const setup=()=>document.querySelectorAll('[data-ot-filter]').forEach(init);setup();document.addEventListener('shopify:section:load',setup);
})();
